import { render } from "./addMemberModal.vue?vue&type=template&id=35047899&scoped=true"
import script from "./addMemberModal.vue?vue&type=script&lang=js"
export * from "./addMemberModal.vue?vue&type=script&lang=js"

import "./addMemberModal.vue?vue&type=style&index=0&id=35047899&lang=scss&scoped=true"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35047899"]])

export default __exports__